var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10_119",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 13,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1422 16.9706C14.9232 17.7516 16.1895 17.7516 16.9706 16.9706C17.7516 16.1895 17.7516 14.9232 16.9706 14.1421L14.1422 11.3137L16.9706 8.4853C17.7516 7.70425 17.7516 6.43792 16.9706 5.65687C16.1895 4.87582 14.9232 4.87582 14.1421 5.65687L11.3137 8.48528L8.4853 5.65685C7.70425 4.8758 6.43792 4.8758 5.65687 5.65685C4.87583 6.4379 4.87583 7.70423 5.65687 8.48527L8.48531 11.3137L5.65686 14.1422C4.87581 14.9232 4.87581 16.1895 5.65686 16.9706C6.43791 17.7516 7.70424 17.7516 8.48529 16.9706L11.3137 14.1421L14.1422 16.9706Z",
    fill: "#505050"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10_119)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.24268,
    y: 3.24265,
    width: 16,
    height: 16,
    fill: "#505050"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.9ace2f1d6bd12b03f57da25939ef5f23.svg";
export { ForwardRef as ReactComponent };